export default __webpack_public_path__ + "static/use-case-3.url-15b2feb125f2357b7d5279df1e93d095.svg";